import { request } from "/src/utils/index.js";

export function getClub() {
  return request.get("sdcom/club/current/get");
}

export function changeClub(params) {
  return request.post("/sdcom/club/current/set", params);
}
